<div
  heroOpacity
  class="delivery-cuisine-hero"
  [style.background-image]="imageURL"
  [style.background-color]="backgroundColor"
  [attr.alt]="imageAlt"
>
  <div sectionSlice size="66%" class="delivery-cuisine-hero-slice"></div>
</div>
